import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "@/lib/motion";

// Scroll-triggered reveal wrapper.
export const Reveal = ({ children, delay = 0, className = "", as = "div" }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial="hidden"
      whileInView="show"
      viewport={viewportOnce}
      variants={{
        hidden: { opacity: 0, y: 16 },
        show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay } },
      }}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
